module.exports = __webpack_public_path__ + "media/offers_icons/osobowe-blue-1d3f06ac.svg";